import React, { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import { Container, Row, Col, Alert, Spinner, Button } from "react-bootstrap";
import HeaderTwo from "../../components/HeaderTwo";
import FooterTwo from "../../components/FooterTwo";
import { BreadcrumbBox } from "../../components/common/Breadcrumb";
import { Styles } from "./styles/universityDetails.js";
import { UNIVERSITY_DETAILS_ENDPOINT } from "../../config/api";

const createInitialState = () => ({
  university: null,
  loading: true,
  error: "",
});

const UniversityDetails = () => {
  const { universityId = "" } = useParams();
  const [state, setState] = useState(() => createInitialState());

  useEffect(() => {
    let isMounted = true;
    const fetchUniversity = async () => {
      setState((prev) => ({ ...prev, loading: true, error: "" }));
      try {
        const response = await fetch(
          UNIVERSITY_DETAILS_ENDPOINT(universityId.trim())
        );

        if (!response.ok) {
          const payload = await response.json().catch(() => ({}));
          throw new Error(payload.message || "Unable to load university.");
        }

        const payload = await response.json();
        if (!isMounted) {
          return;
        }

        setState({
          university: payload.university || null,
          loading: false,
          error: "",
        });
      } catch (err) {
        if (!isMounted) {
          return;
        }
        setState({
          university: null,
          loading: false,
          error: err.message || "Unable to load university.",
        });
      }
    };

    if (universityId.trim()) {
      fetchUniversity();
    } else {
      setState({
        university: null,
        loading: false,
        error: "University not found.",
      });
    }

    return () => {
      isMounted = false;
    };
  }, [universityId]);

  return (
    <Styles>
      <div className="main-wrapper university-details-page">
        <HeaderTwo />
        <BreadcrumbBox title="University Details" />

        <section className="university-details-section">
          <Container>
            <Row className="justify-content-center">
              <Col lg="10">
                {state.loading ? (
                  <div className="loading-state">
                    <Spinner animation="border" role="status" />
                    <span>Loading university information…</span>
                  </div>
                ) : state.error ? (
                  <Alert variant="danger" className="mt-4">
                    {state.error}
                  </Alert>
                ) : !state.university ? (
                  <Alert variant="warning" className="mt-4">
                    University not found.
                  </Alert>
                ) : (
                  <div className="university-card">
                    <div className="header">
                      <div className="title-block">
                        <h2>{state.university.universityName}</h2>
                      </div>
                      {state.university.universityImage && (
                        <div className="image-wrapper">
                          <img
                            src={state.university.universityImage}
                            alt={state.university.universityName}
                          />
                        </div>
                      )}
                    </div>

                    <div className="content">
                      {state.university.description ? (
                        <div
                          className="description"
                          dangerouslySetInnerHTML={{
                            __html: state.university.description,
                          }}
                        />
                      ) : (
                        <p className="text-muted">
                          No description has been added yet.
                        </p>
                      )}
                    </div>

                    <div className="footer-actions">
                      <Button
                        as={Link}
                        to={`${process.env.PUBLIC_URL || ""}/courses`}
                        variant="outline-primary"
                      >
                        Browse Courses
                      </Button>
                    </div>
                  </div>
                )}
              </Col>
            </Row>
          </Container>
        </section>

        <FooterTwo />
      </div>
    </Styles>
  );
};

export default UniversityDetails;
